import { Button, pxToRem, TextInput, useStyles } from '@archipro-design/aria';
import ProductTaggingModal from '@modules/product-tagging/components/product-tagging-modal/ProductTaggingModal';
import React, { useCallback } from 'react';
import { useProductTagging } from '../../context';
import * as S from './ProductTaggingAddSupplierModal.style';

const MESSAGE_MODAL_ADD_SUPPLIER =
    'Type the product suppliers name. We will get in touch with them to see if they would like to be a part of ArchiPro';

interface ProductTaggingAddSupplierModalProps {
    onSubmit: (value: string) => void;
}

const ProductTaggingAddSupplierModal = ({
    onSubmit,
}: ProductTaggingAddSupplierModalProps) => {
    const { css } = useStyles();
    const [input, setInput] = React.useState('');

    const { dispatch } = useProductTagging();

    const handleSubmit = useCallback(() => {
        onSubmit(input);
    }, [input, onSubmit]);

    // Submit the form onKeyDown 'enter'
    React.useEffect(() => {
        const keyDownHandler = (e: KeyboardEvent) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                handleSubmit();
            }
        };

        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, [handleSubmit]);

    return (
        <ProductTaggingModal
            title="Product supplier"
            message={MESSAGE_MODAL_ADD_SUPPLIER}
            hideFooter={true}
            onCancel={() =>
                dispatch({ type: 'ADDING_TAG', payload: undefined })
            }
        >
            <div className={css(S.AddSupplierModalContent)}>
                <form
                    onSubmit={handleSubmit}
                    id="product-tagging-add-supplier-form"
                >
                    <TextInput
                        input={{
                            value: input,
                            placeholder: 'Supplier name',
                            autoFocus: true,
                        }}
                        color={'black'}
                        onChange={(e: React.SyntheticEvent<HTMLElement>) =>
                            setInput((e.target as HTMLInputElement).value)
                        }
                        className={css(S.AddSupplierInput)}
                    />
                    <Button
                        color={'dark'}
                        type={'submit'}
                        size={20}
                        variables={{
                            buttonMinWidth: '100%',
                            buttonPadding: pxToRem(12),
                        }}
                        disabled={!input}
                    >
                        Submit
                    </Button>
                </form>
            </div>
        </ProductTaggingModal>
    );
};

export default ProductTaggingAddSupplierModal;
